import { MilestoneApp, MilestonePayload } from 'api';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import styles from './TotalServiceFee.module.scss';

type Props = {
    milestones: MilestoneApp[] | MilestonePayload[];
    style?: React.CSSProperties;
};

const TotalServiceFee = ({ milestones, style }: Props) => {
    const { language_setting: language } = useSelector((state: RootState) => state.user.entity);
    const { t } = useTranslation();
    const getTotalPrice = () => {
        if (milestones) {
            const prices = milestones.map((mil) => {
                // Handle price with currency prefix (e.g., "CAD 10" or "10")
                const priceStr = String(mil.price).trim();
                // Extract numeric value - remove currency code and parse
                const numericValue = priceStr.replace(/^[A-Z]{3}\s+/, ''); // Remove currency code prefix like "CAD "
                return Number(numericValue) || 0;
            });
            const totalFee = prices.reduce<number>((acc, curr) => {
                const tmp = acc + curr;
                return tmp;
            }, 0);
            return totalFee.toFixed(2);
        }
        return (0).toFixed(2);
    };

    return (
        <section style={{ ...style }} className={styles['total-fee']}>
            <h5 className={styles['total-fee__title']}>{`${t('totalServiceFee', {
                lng: language,
            })}:`}</h5>
            <span className={styles['total-fee__price']}>{getTotalPrice()}</span>
        </section>
    );
};

export default TotalServiceFee;
